import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'

import { WaitingForPayment } from '@dhl/illustrations'

import { ShipmentTemplate } from '~/basket/view/components/ShipmentTemplate'
import { CardForm } from '~/components/card/CardForm'
import { STEP_NAME } from '~/basket/model/constants'
import { withBasket, InjectedBasketProps } from '~/basket/view/withBasket'
import { withRouter } from '~/util/hooks/withRouter'
import { PaymentDialog } from './PaymentDialog'

type Props = InjectedBasketProps

const ParcelshopPaymentPageComponent = ({ stepNavigation, basket }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const PATH = {
    DIALOG: 'dialog',
  }

  const confirm = () => {
    stepNavigation.goToNextStep()
  }

  const newStepNavigation = {
    ...stepNavigation,
    goToNextStep: () => navigate(`${location.pathname}/${PATH.DIALOG}`),
  }

  return (
    <>
      <ShipmentTemplate stepNavigation={newStepNavigation} showNavigation showTotalPrice basket={basket}>
        <CardForm title={t('payment')}>
          <Trans
            i18nKey="payment_otc_explanation"
            components={{ bold: <strong /> }}
            values={{ price: basket.totalPrice.withTax.toFixed(2) }}
          />
          <WaitingForPayment />
        </CardForm>
      </ShipmentTemplate>

      <Routes>
        <Route
          element={
            <PaymentDialog confirm={confirm} hasFailed={basket.orderSubmitFailed} isSubmitting={basket.isSubmitting} />
          }
          path={PATH.DIALOG}
        />
      </Routes>
    </>
  )
}

export const ParcelshopPaymentPage = withBasket(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  withRouter(ParcelshopPaymentPageComponent as any),
  STEP_NAME.PARCELSHOP_PAYMENT
)
